var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessGreyTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.0882,
    cy: 34.0857,
    r: 32.1956,
    fill: "#979797"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8456 27.8486L30.9602 42.7341L25.8861 37.66M34.8847 3.48853C17.5449 3.48853 3.48828 17.5452 3.48828 34.885C3.48828 52.2247 17.5449 66.2814 34.8847 66.2814C52.2245 66.2814 66.2811 52.2247 66.2811 34.885C66.2811 17.5452 52.2245 3.48853 34.8847 3.48853Z",
    stroke: "white",
    strokeWidth: 6.97698,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessGreyTickIcon);
export default __webpack_public_path__ + "static/media/success-grey-tick-icon.3794bf207093bd7c4f94efef89b28971.svg";
export { ForwardRef as ReactComponent };